import { axiosRef } from '.';

export const bookPickUp = (payload: any) => axiosRef.post(`/pickup`, payload);

export const updatePickUp = (payload: any) => axiosRef.put(`/pickup`, payload);

export const cancelPickUp = (payload: any) =>
  axiosRef.delete(`/pickup`, { data: payload });

export const savedQuotes = (payload: any, isAdminView: boolean) => {
  let url = `/books`;
  if (isAdminView) {
    url =
      url + `/admin_quote?page_size=${payload.pageSize}&page=${payload.page}&`;
  } else {
    url = url + `/quote?page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload.account) {
    url = url + `account=${payload.account}&`;
  }
  if (payload.status !== '0') {
    url = url + `is_shipped=${payload.status === '2' ? 'True' : 'False'}&`;
  }
  return axiosRef.get(url);
};

export const addQuote = (payload: any) =>
  axiosRef.post(`/books/quote`, payload);

export const deleteQuote = (id: any) => axiosRef.delete(`/books/quote/${id}`);

export const addTerm = (payload: any) => axiosRef.post(`/books/term`, payload);

export const editTerm = (payload: any) =>
  axiosRef.put(`/books/term/${payload.id}`, payload);

export const deleteTerm = (id: any) => axiosRef.delete(`/books/term/${id}`);

export const savedTermsList = (payload?: any) => {
  let url = `/books/term?`;
  if (payload) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  return axiosRef.get(url);
};

export const addFees = (payload: any) => axiosRef.post(`/books/fee`, payload);

export const editFees = (payload: any) =>
  axiosRef.put(`/books/fee/${payload.id}`, payload);

export const deleteFees = (id: any) => axiosRef.delete(`/books/fee/${id}`);

export const savedFeesList = (payload?: any) => {
  let url = `/books/fee?`;
  if (payload) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search !== '') {
    url = url + `search=${payload.search}`;
  }
  return axiosRef.get(url);
};

export const savedAddressList = (payload?: any) => {
  let url = `/books/address?`;
  if (payload && payload.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload?.search && payload?.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload?.isVendor) {
    url = url + `is_vendor=${payload.isVendor}&`;
  }
  if (payload && payload?.username) {
    url = url + `username=${payload.username}&`;
  }
  if (payload && payload?.account_number) {
    url = url + `account_number=${payload.account_number}&`;
  }
  if (payload && payload?.isOrigin) {
    url = url + `is_origin=${payload.isOrigin}&`;
  }
  if (payload && payload?.isDestination) {
    url = url + `is_destination=${payload.isDestination}&`;
  }
  return axiosRef.get(url);
};

export const addSavedAddress = (payload: any) =>
  axiosRef.post(`/books/address`, payload);

export const deleteSavedAddress = (id: any) =>
  axiosRef.delete(`/books/address/${id}`);

export const updateSavedAddress = (id: string, payload: any) =>
  axiosRef.put(`/books/address/${id}`, payload);

export const uploadSavedAddress = (payload: any) =>
  axiosRef.post(`/books/address_upload`, payload);

export const uploadSavedContact = (payload: any) =>
  axiosRef.post(`/books/contact_upload`, payload);

export const uploadSavedPackage = (payload: any) =>
  axiosRef.post(`/books/package/upload`, payload);

export const savedContactList = (payload?: any) => {
  let url = `/books/contact?`;
  if (payload && payload.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload?.search && payload?.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload?.username) {
    url = url + `username=${payload.username}&`;
  }
  if (payload && payload?.account_number) {
    url = url + `account_number=${payload.account_number}&`;
  }
  if (payload && payload?.isVendor) {
    url = url + `is_vendor=${payload.isVendor}&`;
  }
  if (payload && payload?.isOrigin) {
    url = url + `is_origin=${payload.isOrigin}&`;
  }
  if (payload && payload?.isDestination) {
    url = url + `is_destination=${payload.isDestination}&`;
  }
  return axiosRef.get(url);
};

export const addSavedContact = (payload: any) =>
  axiosRef.post(`/books/contact`, payload);

export const deleteSavedContact = (id: any) =>
  axiosRef.delete(`/books/contact/${id}`);

export const updateSavedContact = (id: string, payload: any) =>
  axiosRef.put(`/books/contact/${id}`, payload);

export const savedBrokersList = (payload: any) => {
  let url = `/books/broker?`;
  if (payload && payload?.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload?.isVendor) {
    url = url + `is_vendor=${payload.isVendor}&`;
  }
  if (payload?.isOrigin) {
    url = url + `is_origin=${payload.isOrigin}&`;
  }
  if (payload?.isDestination) {
    url = url + `is_origin=${payload.isDestination}&`;
  }
  return axiosRef.get(url);
};

export const addSavedBroker = (payload: any) =>
  axiosRef.post(`/books/broker`, payload);

export const deleteSavedBroker = (id: any) =>
  axiosRef.delete(`/books/broker/${id}`);

export const updateSavedBroker = (id: string, payload: any) =>
  axiosRef.put(`/books/broker/${id}`, payload);

export const savedPackagesList = (payload?: any) => {
  let url = `/books/package?`;
  if (payload && payload?.pageSize) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload?.box_type !== '') {
    url = url + `box_type=${payload.box_type}&`;
  }
  if (payload && payload?.search && payload?.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload?.isVendor) {
    url = url + `is_vendor=${payload.isVendor}&`;
  }
  if (payload && payload?.isOrigin) {
    url = url + `is_origin=${payload.isOrigin}&`;
  }
  if (payload && payload?.isDestination) {
    url = url + `is_destination=${payload.isDestination}&`;
  }
  return axiosRef.get(url);
};

export const addSavedPackage = (payload: any) =>
  axiosRef.post(`/books/package`, payload);

export const deleteSavedPackage = (id: any) =>
  axiosRef.delete(`/books/package/${id}`);

export const deleteAllSavedPackage = () => axiosRef.delete(`/books/package`);

export const updateSavedPackage = (id: string, payload: any) =>
  axiosRef.put(`/books/package/${id}`, payload);
export const savedProfilesList = (payload?: any) => {
  let url = `/books/profile?`;
  if (payload && payload.pageSize) {
    url = url + `page_size=${payload.pageSize}&page=${payload.page}&`;
  }
  if (payload && payload.is_pagination !== undefined) {
    url = url + `is_pagination=${payload.is_pagination}&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}`;
  }
  return axiosRef.get(url);
};

export const addSavedProfile = (payload: any) =>
  axiosRef.post(`/books/profile`, payload);

export const editSavedProfile = (payload: any) =>
  axiosRef.put(`/books/profile/${payload.id}`, payload);

export const deleteSavedProfile = (id: any) =>
  axiosRef.delete(`/books/profile/${id}`);

export const overDueList = (payload: any, isAdminView: boolean) => {
  let url = `/`;
  if (isAdminView) {
    url = url + `overdue_admin?`;
  } else {
    url = url + `overdue?`;
  }
  if (payload) {
    url =
      url +
      `page_size=${payload.pageSize}&page=${payload.page}&is_pagination=true&`;
  }
  if (payload && payload.search && payload.search !== '') {
    url = url + `search=${payload.search}&`;
  }
  if (payload && payload.is_pickup_overdue) {
    url = url + `is_pickup_overdue=${payload.is_pickup_overdue}&`;
  }
  if (payload && payload.is_overdue) {
    url = url + `is_overdue=${payload.is_overdue}&`;
  }
  if (payload && payload.username && payload.username !== '') {
    url = url + `username=${payload.username}&`;
  }
  if (payload && payload.carrier) {
    url = url + `carrier=${payload.carrier}&`;
  }
  if (payload && payload.selectedAccount) {
    url = url + `account=${payload.selectedAccount}&`;
  }
  return axiosRef.get(url);
};

export const seenTermsService = (payload: any) =>
  axiosRef.put(`/terms/seen/${payload.account_number}`, payload);

export const agreedTermsService = (payload: any) =>
  axiosRef.put(`/terms/agree/${payload.account_number}`, payload);
